import { IFieldServer } from "@common/redux/forms/interface";

export const addressDefaultValue: IFieldServer = {
  title: "Address ",
  name: "field_set",
  isSection: true,
  fieldType: "SECTION",
  element: "fieldset",
  type: "fieldset",
  grid: {
    width: 1,
  },
  fieldConfig: {
    isPII: false,
    isQrCodeAllowed: false,
  },
  fields: [
    {
      fieldType: "TEXT_INPUT",
      title: "House Number",
      isVisible: true,
      isDisabled: false,
      isRequired: false,
      grid: {
        width: 6,
      },
      canDelete: true,
      canCopy: true,
      canAdd: true,
      type: "TEXT_INPUT",
      name: "House Number",
      // localId: null,
      fields: [],
      fieldConfig: {
        isDuplicateAllowed: true,
        isPII: false,
        isQrCodeAllowed: false,
      },
    },
    {
      fieldType: "TEXT_INPUT",
      title: "Address Line 1",
      isVisible: true,
      isDisabled: false,
      isRequired: false,
      grid: {
        width: 6,
      },
      canDelete: true,
      canCopy: true,
      canAdd: true,
      type: "TEXT_INPUT",
      name: "Address Line 1",
      // "localId": null,
      fields: [],
      fieldConfig: {
        isDuplicateAllowed: true,
        isPII: false,
        isQrCodeAllowed: false,
      },
    },
    {
      fieldType: "TEXT_INPUT",
      title: "Address Line 2",
      isVisible: true,
      isDisabled: false,
      isRequired: false,
      grid: {
        width: 6,
      },
      canDelete: true,
      canCopy: true,
      canAdd: true,
      type: "TEXT_INPUT",
      name: "Address Line 2",
      // localId: null,
      fields: [],
      fieldConfig: {
        isDuplicateAllowed: true,
        isPII: false,
        isQrCodeAllowed: false,
      },
    },
    {
      fieldType: "TEXT_INPUT",
      title: "Landmark",
      isVisible: true,
      isDisabled: false,
      isRequired: false,
      grid: {
        width: 6,
      },
      canDelete: true,
      canCopy: true,
      canAdd: true,
      type: "TEXT_INPUT",
      name: "Landmark",
      // localId: null,
      rules: [],
      fields: [],
      fieldConfig: {
        isDuplicateAllowed: true,
        isPII: false,
        isQrCodeAllowed: false,
      },
    },
    {
      fieldType: "TEXT_INPUT",
      title: "City",
      isVisible: true,
      isDisabled: false,
      isRequired: false,
      grid: {
        width: 6,
      },
      canDelete: true,
      canCopy: true,
      canAdd: true,
      type: "TEXT_INPUT",
      name: "City",
      // "localId": null,
      fields: [],
      fieldConfig: {
        isDuplicateAllowed: true,
        isPII: false,
        isQrCodeAllowed: false,
      },
    },
    {
      fieldType: "TEXT_INPUT",
      title: "State",
      isVisible: true,
      isDisabled: false,
      isRequired: false,
      grid: {
        width: 6,
      },
      canDelete: true,
      canCopy: true,
      canAdd: true,
      type: "TEXT_INPUT",
      name: "State",
      // localId: null,
      fields: [],
      fieldConfig: {
        isDuplicateAllowed: true,
        isPII: false,
        isQrCodeAllowed: false,
      },
    },
    {
      fieldType: "TEXT_INPUT",
      title: "Country",
      isVisible: true,
      isDisabled: false,
      isRequired: false,
      grid: {
        width: 6,
      },
      canDelete: true,
      canCopy: true,
      canAdd: true,
      type: "TEXT_INPUT",
      name: "Country",
      // localId: null,
      fields: [],
      fieldConfig: {
        isDuplicateAllowed: true,
        isPII: false,
        isQrCodeAllowed: false,
      },
    },
    {
      fieldType: "NUMBER_INPUT",
      title: "Pincode",
      isVisible: true,
      description: "",
      isDisabled: false,
      isRequired: false,
      grid: {
        width: 6,
      },
      canDelete: true,
      canCopy: true,
      canAdd: true,
      rules: [
        {
          rule: "DIGIT_COUNT",
          value: "6",
          errorMessage: "Enter valid pincode"
        }
      ],
      fields: [],
      fieldConfig: {
        isDuplicateAllowed: true,
        isPII: false,
        isQrCodeAllowed: false,
        placeHolder: "Enter pincode",
        isNegativeAllowed: false,
        isDecimal: true
      },
    },
  ],
};
